var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000px",
    height: "1000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c2a4b",
    d: "M 717.5,408.5 C 655.562,390.944 601.062,403.944 554,447.5C 537.249,465.748 524.415,486.414 515.5,509.5C 515.167,509.5 514.833,509.5 514.5,509.5C 514.5,509.167 514.5,508.833 514.5,508.5C 527.668,467.337 518.668,431.837 487.5,402C 479.044,395.05 469.71,389.55 459.5,385.5C 459.5,385.167 459.5,384.833 459.5,384.5C 465.406,340.781 487.406,307.948 525.5,286C 558.132,269.24 592.132,265.906 627.5,276C 678.586,295.09 708.42,331.59 717,385.5C 717.5,393.159 717.666,400.826 717.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.588
    },
    fill: "#1d6a96",
    d: "M 459.5,384.5 C 459.5,384.833 459.5,385.167 459.5,385.5C 455.292,436.738 473.625,477.738 514.5,508.5C 514.5,508.833 514.5,509.167 514.5,509.5C 513.89,510.391 513.557,511.391 513.5,512.5C 513.167,512.5 512.833,512.5 512.5,512.5C 475.343,502.967 441.343,509.3 410.5,531.5C 392.402,497.93 364.735,476.597 327.5,467.5C 327.5,467.167 327.5,466.833 327.5,466.5C 332.504,425.666 354.171,397.833 392.5,383C 415.028,376.615 437.362,377.115 459.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#154f77",
    d: "M 459.5,385.5 C 469.71,389.55 479.044,395.05 487.5,402C 518.668,431.837 527.668,467.337 514.5,508.5C 473.625,477.738 455.292,436.738 459.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0185ee",
    d: "M 717.5,408.5 C 710.209,472.291 675.543,512.457 613.5,529C 591.156,533.284 569.156,531.95 547.5,525C 536.383,520.938 525.716,516.104 515.5,510.5C 515.5,510.167 515.5,509.833 515.5,509.5C 524.415,486.414 537.249,465.748 554,447.5C 601.062,403.944 655.562,390.944 717.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#008ffe",
    d: "M 717.5,408.5 C 762.275,424.44 794.442,454.107 814,497.5C 835.749,556.932 827.416,611.599 789,661.5C 747.619,706.962 696.452,724.796 635.5,715C 611.523,710.007 589.856,700.174 570.5,685.5C 570.5,685.167 570.5,684.833 570.5,684.5C 588.261,661.255 595.761,634.922 593,605.5C 584.996,559.33 558.829,528.663 514.5,513.5C 514.5,513.167 514.5,512.833 514.5,512.5C 514.833,511.833 515.167,511.167 515.5,510.5C 525.716,516.104 536.383,520.938 547.5,525C 569.156,531.95 591.156,533.284 613.5,529C 675.543,512.457 710.209,472.291 717.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.587
    },
    fill: "#aad7f1",
    d: "M 327.5,466.5 C 327.5,466.833 327.5,467.167 327.5,467.5C 326.736,510.671 345.403,542.004 383.5,561.5C 383.5,561.833 383.5,562.167 383.5,562.5C 366.288,590.815 362.788,620.815 373,652.5C 376.143,661.452 380.309,669.785 385.5,677.5C 385.5,677.833 385.5,678.167 385.5,678.5C 350.264,709.855 309.597,719.689 263.5,708C 207.093,687.87 177.093,647.87 173.5,588C 177.042,527.545 207.376,487.545 264.5,468C 285.401,462.632 306.401,462.132 327.5,466.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.831
    },
    fill: "#80b7d6",
    d: "M 327.5,467.5 C 364.735,476.597 392.402,497.93 410.5,531.5C 400.048,540.281 391.048,550.281 383.5,561.5C 345.403,542.004 326.736,510.671 327.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#d8e5ed",
    d: "M 512.5,512.5 C 494.378,549.914 464.378,569.247 422.5,570.5C 409.002,570.085 396.002,567.418 383.5,562.5C 383.5,562.167 383.5,561.833 383.5,561.5C 391.048,550.281 400.048,540.281 410.5,531.5C 441.343,509.3 475.343,502.967 512.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.725
    },
    fill: "#fefefe",
    d: "M 512.5,512.5 C 512.833,512.5 513.167,512.5 513.5,512.5C 513.833,512.5 514.167,512.5 514.5,512.5C 514.5,512.833 514.5,513.167 514.5,513.5C 499.646,573.086 512.813,625.419 554,670.5C 559.373,675.377 564.873,680.044 570.5,684.5C 570.5,684.833 570.5,685.167 570.5,685.5C 543.363,718.382 508.363,732.548 465.5,728C 431.258,723.396 404.592,706.896 385.5,678.5C 385.5,678.167 385.5,677.833 385.5,677.5C 414.707,647.885 427.041,612.218 422.5,570.5C 464.378,569.247 494.378,549.914 512.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#bde1ff",
    d: "M 514.5,513.5 C 558.829,528.663 584.996,559.33 593,605.5C 595.761,634.922 588.261,661.255 570.5,684.5C 564.873,680.044 559.373,675.377 554,670.5C 512.813,625.419 499.646,573.086 514.5,513.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#eff7fc",
    d: "M 383.5,562.5 C 396.002,567.418 409.002,570.085 422.5,570.5C 427.041,612.218 414.707,647.885 385.5,677.5C 380.309,669.785 376.143,661.452 373,652.5C 362.788,620.815 366.288,590.815 383.5,562.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.352b638ea88ae796a667f055790368fe.svg";
export { ForwardRef as ReactComponent };